import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, MapPin, Phone } from 'lucide-react';
function BacklinkLine() {
  const linkClass = 'no-underline hover:text-gold transition-colors';
  return <div className="mt-6 flex flex-col items-center gap-1 text-center text-xs text-sand/60 sm:flex-row sm:justify-center sm:gap-3" data-id="element-73" data-mp="32ovz90bar3ms">
      <span data-id="element-74" data-mp="36nd5lhmw8a35">
        <a href="https://adroimarketing.com/#/design/websites" target="_blank" rel="nofollow noopener noreferrer" className={linkClass} data-id="element-75" data-mp="36n3bbhutfgrn">
          Website Design
        </a>
        ,{' '}
        <a href="https://adroimarketing.com/#/marketing/local-seo" target="_blank" rel="nofollow noopener noreferrer" className={linkClass} data-id="element-76" data-mp="3lf57orxofrmx">
          Marketing
        </a>{' '}
        by{' '}
        <a href="https://adroimarketing.com/" target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-77" data-mp="2a19tpmiidoxa">
          Ad ROI Marketing
        </a>
      </span>
      <span className="hidden opacity-50 sm:inline" aria-hidden="true" data-id="element-78" data-mp="3lbdd6ucasbmc">
        |
      </span>
      <span data-id="element-79" data-mp="3gcjvsqtw40gw">
        <a href="https://adroimarketing.com/#/crm" target="_blank" rel="nofollow noopener noreferrer" className={linkClass} data-id="element-80" data-mp="3v7q4xmoa8feg">
          Sales Automation CRM
        </a>{' '}
        by{' '}
        <a href="https://1Dash.Pro" target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-81" data-mp="81ywcgswhu2x">
          1Dash.Pro
        </a>
      </span>
    </div>;
}
export function Footer() {
  return <footer className="bg-navy text-sand pt-16 pb-8" data-id="element-82" data-mp="huo533x2gtuk">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-83" data-mp="cus134odd2f0">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-84" data-mp="qt8ipqnrsdbx">
          <div className="col-span-1 md:col-span-2" data-id="element-85" data-mp="qrfba95c1p2v">
            <h3 className="font-serif text-2xl tracking-wider uppercase mb-4 text-white" data-id="element-86" data-mp="mspq3ue1z38o">
              Cabo Collection
            </h3>
            <p className="text-sand/80 max-w-md mb-6 font-light leading-relaxed" data-id="element-87" data-mp="twxtbfc15kby">
              More than real estate. We are your gateway to the ultimate Cabo
              lifestyle, connecting you with the finest properties and a vetted
              collective of local professionals.
            </p>
            <div className="flex space-x-4" data-id="element-88" data-mp="18m3q6wneaygo">
              <a href="#" className="text-sand/80 hover:text-gold transition-colors" data-id="element-89" data-mp="1cmdw69b6tovj">
                <Instagram size={20} data-id="element-90" data-mp="1hj4c8wmzskgy" />
              </a>
              <a href="#" className="text-sand/80 hover:text-gold transition-colors" data-id="element-91" data-mp="1mj8uar3jtn9a">
                <Facebook size={20} data-id="element-92" data-mp="1rhk637dem7u5" />
              </a>
            </div>
          </div>

          <div data-id="element-93" data-mp="3oc6r0y0g4zzi">
            <h4 className="font-serif text-lg mb-4 text-white" data-id="element-94" data-mp="3ocpzzp84ce1e">Explore</h4>
            <ul className="space-y-3 text-sm text-sand/80" data-id="element-95" data-mp="3tb9lxpmppptr">
              <li data-id="element-96" data-mp="2af3qtkngqtgz">
                <Link to="/buyers" className="hover:text-gold transition-colors" data-id="element-97" data-mp="2afnb380l5ty6">
                  For Buyers
                </Link>
              </li>
              <li data-id="element-98" data-mp="21ma637p8z1vq">
                <Link to="/sellers" className="hover:text-gold transition-colors" data-id="element-99" data-mp="21nlczgdzopr2">
                  For Sellers
                </Link>
              </li>
              <li data-id="element-100" data-mp="2tcoeioehrm00">
                <Link to="/collective" className="hover:text-gold transition-colors" data-id="element-101" data-mp="2td6k4bn1nckl">
                  The Collective
                </Link>
              </li>
              <li data-id="element-102" data-mp="2kf4efisd7vqz">
                <Link to="/contact" className="hover:text-gold transition-colors" data-id="element-103" data-mp="2fego6zbynixt">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-104" data-mp="13y9xkq9pt3f2">
            <h4 className="font-serif text-lg mb-4 text-white" data-id="element-105" data-mp="13xqdp40i84ye">Connect</h4>
            <ul className="space-y-3 text-sm text-sand/80" data-id="element-106" data-mp="2ruogh71yulzf">
              <li className="flex items-center space-x-2" data-id="element-107" data-mp="2wmg1l22crzi6">
                <MapPin size={16} className="text-gold" data-id="element-108" data-mp="2wnr28t0i4r52" />
                <span data-id="element-109" data-mp="2ivkvtyn5hyit">Cabo San Lucas, BCS, Mexico</span>
              </li>
              <li className="flex items-center space-x-2" data-id="element-110" data-mp="2nu5p1e3zjhxr">
                <Phone size={16} className="text-gold" data-id="element-111" data-mp="2nunqqq9f2od2" />
                <span data-id="element-112" data-mp="3bj725enrjh9d">+1 (555) 123-4567</span>
              </li>
              <li className="flex items-center space-x-2" data-id="element-113" data-mp="3bhm95th3k6dm">
                <Mail size={16} className="text-gold" data-id="element-114" data-mp="3fkacxmqyen3q" />
                <span data-id="element-115" data-mp="31lj4ogyrvvni">hello@cabocollection.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-sand/20 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-sand/60" data-id="element-116" data-mp="36k45oilumjd0">
          <p data-id="element-117" data-mp="1q5m6s38yi1e5">
            &copy; {new Date().getFullYear()} Cabo Collection. All rights
            reserved.
          </p>
          <p className="mt-2 md:mt-0" data-id="element-118" data-mp="1v3dusm6hd3d2">
            Looking for investment deals? Visit our sister site:{' '}
            <a href="https://cabodealflow.com" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-white transition-colors" data-id="element-119" data-mp="1nnsfpub8tv3s">
              CaboDealFlow.com
            </a>
          </p>
        </div>
        <BacklinkLine data-id="element-120" data-mp="1rlgdr688g3zw" />
      </div>
    </footer>;
}